<template>
    <BreadCrumb PageTitle="Liste des menus" />
    <ListeMenu/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import ListeMenu from "@/components/Menus/ListeMenu.vue";
  
    export default defineComponent({
      name: "ListeMenuPage",
      components: {
        BreadCrumb,
         ListeMenu,
      },
    });
  </script>